import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Google Analytics SPA pageview tracker.
 * Sends a `page_view` event to gtag on every React Router location change.
 * The gtag snippet must already be loaded (see /public/index.html).
 */
export default function useAnalytics() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;

    const path = location.pathname + location.search;
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);
}
